// src/components/SocialLinksBar.jsx

import React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

import { colors } from '../../styles/PageStyles'; // Assuming this is the correct path for colors

// --- Import your SVG icons as React components ---
import { ReactComponent as FacebookIcon } from '../svg/facebook.svg';
import { ReactComponent as InstagramIcon } from '../svg/instagram.svg';
import { ReactComponent as LinkedInIcon } from '../svg/linkedin.svg';

/**
 * Renders a social media bar with clickable SVG icons.
 * The icons are imported directly as React components.
 *
 * @param {object} props - Component props.
 * @param {object} [props.style] - Optional inline style for the outermost container.
 */
const SocialLinksBar = ({ style }) => {

    const socialLinks = [
        { name: 'Facebook', url: 'https://www.facebook.com/profile.php?id=61551785676432', IconComponent: FacebookIcon },
        { name: 'Instagram', url: 'https://www.instagram.com/thegoddardproject/', IconComponent: InstagramIcon },
        { name: 'LinkedIn', url: 'https://www.linkedin.com/company/the-wonder-mission', IconComponent: LinkedInIcon },
    ];

    const iconSize = '40px';
    const gap = '15px';

    return (
        <Box
            // REMOVED: className="newsletter-social-bar social-dark container-fluid"
            sx={{
                width: '100%',
                backgroundColor: 'transparent',
                color: colors.textColor,
                ...style,
            }}
        >
            <Box
                // REMOVED: className="newsletter-row row"
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', lg: 'column' },
                    justifyContent: { xs: 'center', lg: 'space-between' },
                    alignItems: 'center',
                    py: 2,
                }}
            >
                {/* Social Icons Column - NOW ALWAYS VISIBLE ON ALL SCREENS */}
                <Box
                    // REMOVED: className="social-col my-auto col col-xl-3 col-lg-3 d-none d-lg-block"
                    sx={{
                        // This ensures it's always displayed as a block element
                        display: 'block', // Explicitly display on all breakpoints
                        flexGrow: 0,
                        flexShrink: 0,
                        width: { xs: '100%', lg: '25%', xl: '25%' }, // Full width on mobile, smaller on large
                        textAlign: 'center',
                    }}
                >
                    <Box className="social-wrap"> {/* Keep social-wrap if you have external CSS for it */}
                        <List
                            className="follow-icons social-icons-svg" // Keep if you have external CSS for these
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                listStyle: 'none',
                                p: 0,
                                m: 0,
                                gap: gap,
                            }}
                        >
                            {socialLinks.map((link) => (
                                <ListItem
                                    key={link.name}
                                    sx={{
                                        width: iconSize,
                                        height: iconSize,
                                        p: 0,
                                        m: 0,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        overflow: 'hidden',
                                        backgroundColor: 'black', // KEEP FOR DEBUGGING, REMOVE LATER
                                        borderRadius: '4px', // KEEP FOR DEBUGGING, REMOVE LATER
                                        margin: '5px', // KEEP FOR DEBUGGING, REMOVE LATER
                                    }}
                                >
                                    <a
                                        className="follow-link" // Keep if you have external CSS for this
                                        href={link.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label={`Follow on ${link.name}`}
                                        sx={{
                                            color: colors.iconColor,
                                            display: 'block',
                                            width: '100%',
                                            height: '100%',
                                            lineHeight: 0,
                                            transition: 'transform 0.2s ease-in-out, fill 0.2s ease-in-out',
                                            '&:hover': {
                                                transform: 'scale(1.1)',
                                            },
                                        }}
                                    >
                                        <link.IconComponent
                                            width="100%"
                                            height="100%"
                                            fill="currentColor"
                                            sx={{
                                                '&:hover': {
                                                    fill: colors.accentColor,
                                                },
                                            }}
                                        />
                                    </a>
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                </Box>

                {/* Empty column to take up space */}
                <Box
                    // REMOVED: className="form-button-col my-auto col col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12"
                    sx={{
                        flexGrow: 1,
                        flexShrink: 1,
                        width: { xs: '100%', lg: '75%', xl: '75%' },
                        textAlign: { xs: 'center', lg: 'right' },
                        py: { xs: 2, lg: 0 },
                    }}
                >
                </Box>
            </Box>
        </Box>
    );
};

export default SocialLinksBar;